import { useLang } from 'hooks/lang';

import { actions, packageStatusConfig } from 'entities';

import { DropdownMenuItem } from 'components/Blocks';
import { CircleXIcon } from 'components/Icons';

import { useConfirmation } from 'providers/Confirmation';
import { useSingleJustification } from 'providers/Justification';
import { usePackage } from '../context';

export function CancelPackage(): JSX.Element | null {
  const { data, overwrite } = usePackage();
  const { t } = useLang();

  const { requestConfirmation } = useConfirmation();

  const cancelPackage = actions.invoice.cancelPackage.use({
    onSuccess: () =>
      overwrite((old) => ({
        ...old,
        status: packageStatusConfig.canceled.code,
      })),
  });

  const cancel = useSingleJustification({
    text: t('justification-package-cancelation'),

    onConfirm: async (justification) =>
      requestConfirmation({
        title: t('confirm-package-cancelation')!,
        type: 'irreversible',
        onConfirm: () =>
          cancelPackage.execute({
            justification,
            packageId: data.id,
          }),
      }),
  });

  return (
    <DropdownMenuItem onClick={cancel}>
      <CircleXIcon />
      {t('cancel')}
    </DropdownMenuItem>
  );
}
